



















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getCurrentTime } from "@/utils/base";
import {
  GetTemList,
  EditContent,
  PostCepingContent,
  GetContentDetail,
} from "@/request/common";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";
import { IfEmpty } from "@/components/template-transfer-pc/template/common";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    TemplateContent,
  },
})
export default class Name extends Vue {
  private dataQuery: any = {
    name: "",
    content_id: "",
    related_type: "",
  };
  private data: any = [];
  private leftTabNav: any = [];
  private cLeftTab: any = "";
  private disabledDate: any = this.endDate();
  private ifCompose: any = true;
  private ifPlay: boolean = false;
  private playIndex: any = null;
  private currentUtterance: SpeechSynthesisUtterance | null = null;
  private keyboardHandler: ((e: KeyboardEvent) => void) | null = null;
  private redIndex: any = null;

  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private startPlayAudio() {
    this.ifCompose = false;
    this.ifPlay = true;
    this.playIndex = 0;
    // 添加键盘事件监听
    this.keyboardHandler = this.handleKeyboardInput.bind(this);
    window.addEventListener("keydown", this.keyboardHandler);
    // 需要清除所有题目的值
    this.data.data.forEach((item: any) => {
      if (item.type == "计分单选") {
        item.value = {};
      }
    });
    this.playAudio(0);
    // 页面滚动到最上面
    const parent = (document as any).getElementById("liangbiao-detail");
    parent.scrollTop = 0;
  }
  private stopPlayAudio() {
    this.ifPlay = false;
    this.ifCompose = true;
    this.playIndex = null;
    // 移除键盘事件监听
    if (this.keyboardHandler) {
      window.removeEventListener("keydown", this.keyboardHandler);
      this.keyboardHandler = null;
    }
    this.stopAudio();
  }
  private async playAudio(index: any) {
    if (
      (this.data.data[index].type != "单选" &&
        this.data.data[index].type != "计分单选") ||
      this.data.data[index].hide
    ) {
      this.playAudio(index + 1);
      return;
    } else {
      this.playIndex = index;
      // 这里需要判断下，如果下一题不在可视区域，则滚动到下一题
      const nextQuestion = document.getElementById(`liangbiao${index}`);
      if (nextQuestion) {
        const parent = (document as any).getElementById("liangbiao-detail");
        // 获取parent的高度
        const parentHeight = parent.offsetHeight;
        // 获取nextQuestion的高度
        const nextQuestionHeight = nextQuestion.offsetHeight;
        // 如果nextQuestion不在可视区域，则滚动到下一题
        if (
          nextQuestion.offsetTop + nextQuestionHeight >
          parentHeight + parent.offsetTop + parent.scrollTop
        ) {
          parent.scrollTop =
            nextQuestion.offsetTop +
            nextQuestionHeight -
            parentHeight -
            parent.offsetTop;
        }
      }
    }
    //前端语音读题,把文字生成语音读出来
    const text = this.data.data[index].title;
    await this.playCountdown(text);
  }
  private stopAudio() {
    if (this.currentUtterance) {
      this.currentUtterance.onend = null;
      this.currentUtterance = null;
    }
    window.speechSynthesis.cancel();
  }
  private playCountdown(val: any): Promise<void> {
    return new Promise((resolve) => {
      this.stopAudio();

      // 其他题目编辑状态改为false,当前题目编辑状态改为true
      this.data.data.forEach((item: any, index: any) => {
        item.edit = index == this.playIndex;
      });
      const text = val;
      const utterance = new SpeechSynthesisUtterance(text);
      this.currentUtterance = utterance;

      // 设置中文语音
      const voices = window.speechSynthesis.getVoices();
      const chineseVoice = voices.find((voice) => voice.lang.startsWith("zh"));
      if (chineseVoice) {
        utterance.voice = chineseVoice;
      }

      utterance.onend = () => {
        this.currentUtterance = null;
        resolve();
      };

      window.speechSynthesis.speak(utterance);
    });
  }
  private radioScoreClick(option: any, optionIndex: any, tIndex: any) {
    if (!this.ifCompose && !this.data.data[tIndex].edit) {
      return;
    }
    if (
      this.data.data[tIndex].value &&
      this.data.data[tIndex].value.name &&
      this.data.data[tIndex].value.name === option.name
    ) {
      this.data.data[tIndex].value = {};
    } else {
      this.data.data[tIndex].value = option;
    }
    this.$forceUpdate();
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          (this.data.data[i].hide == true &&
            this.data.data[i].type != "段落标题") ||
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }
  }
  private radioClick(ev: any, tIndex: any) {
    if (!this.ifCompose && !this.data.data[tIndex].edit) {
      return;
    }
    this.data.data[tIndex].value === ev
      ? (this.data.data[tIndex].value = "")
      : (this.data.data[tIndex].value = ev);
    this.$forceUpdate();
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          !this.data.data[i].hide &&
          this.data.data[i].type != "段落标题" &&
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }

    // this.changeHide();
  }
  private scrollTo(item: any) {
    if (this.ifPlay) {
      this.$message.warning("请先关闭语音播放");
      return;
    }
    this.cLeftTab = item.title;
    const parent = (document as any).getElementById("liangbiao-detail");
    const child = (document as any).getElementById("liangbiao" + item.index);
    parent.scrollTop = child.offsetTop - parent.offsetTop;
  }
  private scrollEvent() {
    const parent = (document as any).getElementById("liangbiao-detail");
    if (parent) {
      const scrollTop = parent.scrollTop;
      const parentTop = parent.offsetTop + 14;
      this.data.data.forEach((ele: any, i: any) => {
        if (i < this.leftTabNav.length) {
          const cuEle = document.getElementById("liangbiao" + i);
          const nextEle = document.getElementById("liangbiao" + (i + 1));
          if (cuEle && nextEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            const nextTop = nextEle.offsetTop - parentTop;
            if (scrollTop >= cuTop && scrollTop < nextTop) {
              // 找到对应的leftTabNav
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        } else {
          const cuEle = document.getElementById("liangbiao" + i);
          if (cuEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            if (scrollTop >= cuTop) {
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        }
      });
    }
  }
  private getLeftTab() {
    let leftTabNav: any = [];
    this.data.data.forEach((items: any, index: any) => {
      if (items.group) {
        // 如果标题结尾是“判定”，则不加入左侧导航
        leftTabNav.push({ ...items, children: [], index: index });
      } else {
        if (leftTabNav.length > 0) {
          leftTabNav[leftTabNav.length - 1].children.push(items);
        }
      }
    });
    this.leftTabNav = leftTabNav;
    if (leftTabNav.length > 0) {
      this.cLeftTab = leftTabNav[0].title;
    }
  }
  private getData() {
    if (this.dataQuery.content_id) {
      this.getContent();
    } else {
      this.getTemplate();
    }
  }
  private getTemplate() {
    const params: any = {
      params: {
        name: this.dataQuery.name,
        page: 1,
        ignore_permissions: "true",
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemList(this, params, loading).then((res: any) => {
      this.data = {
        template: {
          name: res.data[0].name,
          id: res.data[0].id,
        },
        collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        data: res.data[0].fields,
      };
      this.getLeftTab();
    });
  }
  private getContent() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.dataQuery.content_id, loading).then(
      (res: any) => {
        this.data = res.data;
        if (!this.data.name && this.data.template && this.data.template.name) {
          this.data.name = this.data.template.name;
        }
        this.getLeftTab();
      }
    );
  }
  private updateContent(e: any) {
    this.data = e;
  }
  /**
   * 保存前的验证
   */
  private savePre() {
    return new Promise((resolve, reject) => {
      // 判断必填项是否填完
      for (let i = 0; i < this.data.data.length; i++) {
        const weitian = IfEmpty(this.data.data[i]);
        if (weitian) {
          // 弹提示哪个未填,并用红框框上
          this.$message.warning(this.data.data[i].title + "为必填项！");
          this.redIndex = i;
          // 滚动到没填的题目
          const parent = (document as any).getElementById("liangbiao-detail");
          const child = (document as any).getElementById("liangbiao" + i);
          parent.scrollTop = child.offsetTop - parent.offsetTop;
          resolve(false);
          return;
        }
      }
      resolve(true);
    });
  }
  private save() {
    return new Promise((resolve, reject) => {
      this.savePre().then((res: any) => {
        if (res) {
          // 必填验证成功
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.dataQuery.content_id) {
            EditContent(
              this,
              this.dataQuery.content_id,
              this.data,
              loading
            ).then((res: any) => {
              this.$message.success("保存成功！");
              this.ifCompose = false;
              this.getData();
              resolve(true);
            });
          } else {
            const params: any = {
              collect_time: this.data.collect_time,
              patient: this.patient.id,
              data: this.data.data,
              template: this.data.template,
              related_type: this.dataQuery.related_type,
            };
            PostCepingContent(this, params, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.dataQuery.content_id = res.data.id;
              this.ifCompose = false;
              this.getData();
              resolve(res);
            });
          }
        } else {
          // 必填验证失败
        }
      });
    });
  }
  private edit() {
    this.ifCompose = true;
  }
  private mounted() {
    if (this.$route.query.name) {
      this.dataQuery.name = this.$route.query.name;
    }
    if (this.$route.query.related_type) {
      this.dataQuery.related_type = this.$route.query.related_type;
    }
    if (this.$route.query.content_id) {
      this.dataQuery.content_id = this.$route.query.content_id;
    }
    this.getData();
  }
  private beforeDestroy() {
    // 确保在组件销毁时移除事件监听
    if (this.keyboardHandler) {
      window.removeEventListener("keydown", this.keyboardHandler);
    }
    this.stopAudio();
  }
  private handleKeyboardInput(e: KeyboardEvent) {
    if (!this.ifPlay || this.playIndex === null) return;

    const currentQuestion = this.data.data[this.playIndex];
    if (!currentQuestion || !currentQuestion.options) return;

    // 只处理数字键
    const key = parseInt(e.key);
    if (isNaN(key)) return;

    // 检查选项是否存在
    if (key > 0 && key <= currentQuestion.options.length) {
      // 单选直接设置值
      const option = currentQuestion.options[key - 1];
      if (currentQuestion.type == "计分单选") {
        this.radioScoreClick(option, key - 1, this.playIndex);
      } else {
        this.radioClick(option, this.playIndex);
      }
    }
  }
}
